import styled, { css } from 'styled-components'

export const VerificationCodeInputStyled = styled('div')(
  ({ theme }) => css`
    ${theme.mixins.flexCenter}
    flex-direction: column;
    height: 150px;
  `
)
